// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1c9am"};